import React from 'react'

const contextType = {
	/**
	 * Titre de la popin
	 * @type string
	 */
	title: '',
	/**
	 * Contenu de la popin
	 * @type React.Component
	 */
	content: <React.Fragment />,
	/**
	 * Liste des actions de la popin
	 * @type Array<React.Component>
	 */
	actions: [],
	/**
	 * Type de la popin
	 * @type string
	 */
	type: '',
	/**
	 * Méthode permettant d'ouvrir la popin
	 */
	openDialog: () => {},
	/**
	 * Méthode permettant de fermer la popin
	 * @type closeDialogType
	 */
	closeDialog: () => {}
}

/**
 * Contexte relatif aux popins
 * @type {React.Context<{openDialog: openDialogType, title: string, actions: Array<React.Component>, content: React.Component, type: string closeDialog, closeDialog: closeDialogType}>}
 */
export const DialogContext = React.createContext(contextType)